import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useFiscalNote = (id) => useQuery({ queryKey: ['fiscal-note', id], queryFn: async () => {
    if(!id) return {}
    const callback = await API.get(`/fiscal/${id}`)
    return callback?.data
}})

export default useFiscalNote